// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__5GNs3","unreadBadge":"styles_unreadBadge__26Oy7","modalContent":"styles_modalContent__Lz_gG","modal":"styles_modal__2tv21"};